<template>
  <v-data-table
    :headers="headers"
    mobile-breakpoint="0"
    :items="busStudents"
    :server-items-length="totalItems"
    :items-per-page="10"
    :options.sync="pagination"
    item-key="id"
    loading-text="Đang Tải"
    :loading="loading"
    :footer-props="footerTable"
    sort-by="title"
    no-data-text="Không có dữ liệu"
  >
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.class`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="'/class/' + (item.student.currentClass && item.student.currentClass.id)"
      >
        {{ item.student.currentClass && item.student.currentClass.title }}
      </router-link>
    </template>
    <template v-slot:[`item.buses`]="{ item }">
      <div v-for="bus in item.buses" :key="bus.id" class="d-flex align-center">
        <router-link style="text-decoration: none; white-space: nowrap" :to="'/bus/' + bus.id"
          >{{ bus.name }}
        </router-link>
        <div class="d-flex align-center ml-1" v-if="item.metadata">
          (
          <div v-for="(day, index) in item.metadata[bus.id]" :key="index">
            <span class="ml-1">{{ day | scheduleDay }}{{ index === item.metadata[bus.id].length - 1 ? '' : ',' }}</span>
          </div>
          )
        </div>
      </div>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

const originHeaders = [
  {
    text: 'Tên học sinh',
    value: 'student',
    align: 'left',
    width: '30%',
    sortable: false
  },
  {
    text: 'Khối',
    value: 'student.grade.title',
    align: 'left',
    width: '15%',

    sortable: false
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    width: '15%',

    sortable: false
  },
  {
    text: 'Tên tuyến',
    value: 'buses',
    align: 'left',
    width: '40%',
    sortable: false
  }
]

export default {
  components: { CardStudentName },
  props: {},
  data() {
    return {
      selected: [],
      search: '',
      headers: originHeaders,
      editDialog: false,
      title: '',
      busTableOptions: {},
      busStops: [],
      loading: false,
      pagination: {}
    }
  },
  methods: {
    ...mapActions('BusStudents', ['fetchBusStudents', 'getBusStudentByPagination'])
  },
  computed: {
    ...mapState('BusStudents', ['studentBuses', 'busStudents', 'pageText', 'totalItems']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'items-per-page-options': [5, 10, 15],
        'page-text': this.pageText
      }
      return footer
    }
  },

  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          this.loading = true
          await this.getBusStudentByPagination({ page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
          this.loading = false
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped></style>
